module.exports = __webpack_public_path__ + "img/squares_ss.53cc79a4.png";